<template>
  <footer class="app-footer" :style="{marginLeft:footerMarginLeft}">
   <!-- <a style="margin-left: 200px;">WZ</a> &copy; 2017 creativeLabs.
    <span class="float-right">Powered by <a href="http://coreui.io">WZ</a></span>-->
  </footer>
</template>
<script>
export default {
  name: 'footer',
  data(){
      return{
          footerMarginLeft:"290px"
      }
    },
    created(){
        window.addEventListener('resize', this.handleResize);
        this.changeMargin();
    },
    methods:{
        handleResize(){
         this.changeMargin();
      },
      changeMargin(){
          const  width = document.body.clientWidth ||document.body.scrollWidth;
          const big = this.$store.getters.sidebarBigWidth;
          const small = this.$store.getters.sidebarSmallWidth;
          const critical = this.$store.getters.sidebarCriticalValue;
          if(width > critical){
              this.footerMarginLeft = big+"px";
          }else {
              this.footerMarginLeft = small+"px";
          }
      }
    }
}
</script>



// WEBPACK FOOTER //
// Footer.vue?0f93eeaa